export const ConfigData = [
  {
    id: "name",
    name: "Campaign Name",
    isShow: true,
    width: "250px",
    filter: true,
  },
  {
    id: "description",
    name: "Campaign Description",
    isShow: true,
    width: "250px",
    filter: true,
  },
   {
    id: "type",
    name: "Campaign Type",
    isShow: true,
    width: "250px",
    filter: true,
  },
  {
    id: "reward_type",
    name: "Reward Type",
    isShow: true,
    width: "250px",
    filter: true,
  },
  {
    id: "created_by.name",
    name: "Created By",
    isShow: true,
    width: "150px",
    filter: true,
  },
  {
    id: "created_on",
    name: "Created On",
    isShow: true,
    width: "160px",
    filter: false,
    format: "date-time"
  },

  {
    id: "status",
    name: "Campaign Status",
    isShow: true,
    width: "160px",
    filter: false,
  },
  {
    id: "updated_by.name",
    name: "Last Submitted By",
    isShow: true,
    width: "250px",
    filter: true,
  },
  {
    id: "is_show_status",
    name: "is_show_status",
    isShow: false
  },
  {
    id: "button",
    name: "Action",
    type: "dropdown",
    isShow: true,
    width: "117px",
    action: ["View Details", "Update Status", "Delete"],
    permission: {
      ["View Details"]: {
        id: "View Details",
        permission: ["gamifications.access_campaign"]
      },
      ["Delete"]: {
        id: "Delete",
        permission: ["gamifications.delete_campaign"],
      },
      ["Update Status"]: {
        id: "Update Status",
        permission: ["gamifications.campaign_admin","gamifications.approve_nominees"],
      },
    },
    isshowAction: {
      item: "is_show_status",
      children: [
        {
          id: "Update Status",
          value: "Update Status",
          notShowCondition: 'false',
        }
      ],
    },
    
    
  },
];

export const statusConfig = [
  {
    id: "Draft",
    name: "Draft",
  },
  {
    id: "Pending Approval",
    name: "Pending Approval",
  },
  {
    id: "Approved",
    name: "Approved",
  },
  {
    id: "Rejected",
    name: "Rejected",
  },
  {
    id: "Scheduled",
    name: "Scheduled",
  },
  {
    id: "Published",
    name: "Published",
  },
  {
    id: "Closed",
    name: "Closed",
  },
];


export const statusConfigForPublishScheduled = [
  {
    id: "Closed",
    name: "Closed",
  }
];

export const statusConfigForCampaignApprover = [
  {
    id: "Approved",
    name: "Approved",
  },
  {
    id: "Rejected",
    name: "Rejected",
  },
  {
    id: "Closed",
    name: "Closed",
  }
];

export const statusConfigForPendingNomination = [
  {
    id: "Scheduled",
    name: "Scheduled",
  },
  {
    id: "Published",
    name: "Published",
  },
  {
    id: "Closed",
    name: "Closed",
  },
];

export const statusConfigForCreated = [
  {
    id: "Submitted",
    name: "Submitted",
  },
];